<template>
  <div class="tel-box">
    <p class="tel-txt">au PAY スマートローン会員さま専用デスク</p>
    <p class="tel-num"><img src="@/assets/images/page/tem001/tel.gif" class="tel-img" alt="">0570-003-858</p>
  </div>
</template>

<script>

export default {
  name: 'tel-box'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.tel-box {
  position: relative;
  text-align: center;
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 2px 2px rgba($secondary,0.6);
  @include mq-down(md) {
    padding-top: 14px;
    padding-bottom: 14px;
    margin-bottom: 14px;
  }
  @include mq-up(md) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 14px;
    padding-bottom: 14px;
    margin-bottom: 30px;
  }
}

.tel-txt {
  line-height: 1;
  @include mq-down(md) {
    font-size: 14px;
    margin-bottom: 8px;
  }
  @include mq-up(md) {
    font-size: 18px;
    margin-right: 14px;
    margin-bottom: 0;
  }
}

.tel-num {
  display: flex;
  margin-bottom: 0;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: $primary;
  @include mq-down(md) {
    font-size: 28px;
    line-height: 30px;
  }
  @include mq-up(md) {
    font-size: 36px;
    line-height: 37px;
  }
}

.tel-img {
  margin-right: 8px;
  @include mq-down(md) {
    width: 30px;
  }
  @include mq-up(md) {
    width: 37px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/box/TelBox.vue